import React, { useState, useEffect } from "react";
import Icon from "components/shared/Icon";

function GuideListViewControl(props) {
  const [viewOption, setViewOption] = useState(props.defaultViewOption);

  // changes to query params will be passed downstream to this component
  useEffect(() => {
    if (
      props.queryParamOptions &&
      props.queryParamOptions.viewOption !== viewOption
    ) {
      const viewOptionFromQP =
        props.queryParamOptions.viewOption || props.viewOptions.list;
      setViewOption(viewOptionFromQP);
      props.onSetViewOption(viewOptionFromQP, false);
    }
  }, [props.queryParamOptions]);

  const viewOptionIsList = viewOption === props.viewOptions.list;
  const viewOptionIsGrid = viewOption === props.viewOptions.grid;

  const handleClickViewOptionList = () => {
    setViewOption(props.viewOptions.list);
    props.onSetViewOption(props.viewOptions.list);
  };

  const handleClickViewOptionGrid = () => {
    setViewOption(props.viewOptions.grid);
    props.onSetViewOption(props.viewOptions.grid);
  };

  return (
    <div className="guide-list__control guide-list__control--view">
      <span>View:</span>
      <button
        aria-label="View as list"
        className={`guide-list__view-option btn btn-borderless btn-icon ${
          viewOptionIsList ? "guide-list__view-option--active" : ""
        }`}
        data-testid="GuideList-ListView"
        onClick={handleClickViewOptionList}
        type="button"
      >
        <Icon name="list" size="sm" />
      </button>
      <button
        aria-label="View as grid"
        className={`guide-list__view-option btn btn-borderless btn-icon ${
          viewOptionIsGrid ? "guide-list__view-option--active" : ""
        }`}
        data-testid="GuideList-GridView"
        onClick={handleClickViewOptionGrid}
        type="button"
      >
        <Icon name="grid" size="sm" />
      </button>
    </div>
  );
}

export default GuideListViewControl;
